import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { adminKeys } from "@/lib/query-keys";

/**
 * Acepta usuarios en la beta y les crea su suscripción TRIAL (acción de admin).
 * Invalida el listado de usuarios para reflejar el nuevo estado.
 */
export function useAcceptTrial() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userIds: string[]) =>
      // `accepted` cuenta solo los realmente aceptados: los que ya lo estaban
      // vuelven con success=false (la operación es idempotente).
      fetchToBackend<{ accepted: number }>("/admin/accept-trial", {
        method: "POST",
        body: JSON.stringify({ userIds }),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminKeys.users });
    },
  });
}
